import { render } from "./TheHeader.vue?vue&type=template&id=7e2f9685"
const script = {}

import exportComponent from "/Volumes/Localhost/Sites/www/notifyapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__